import { FC, useEffect, useState, useMemo, ChangeEvent } from 'react';
import LeagueService from '../../../services/league'
import AdminLeagueService from '../../../services/admin/adminLeague'
import HelperService from '../../../services/helper'
import useNotyf from '../../../context/useNotify';
import { League } from '../../../models/league';

interface Props {
    leagueId: string
    refresh: () => void
}

const StartLeagueModal: FC<Props> = ({ leagueId, refresh }) => {
  const notyf = useNotyf()

    // Data
    const [ league, setLeague ] = useState<League>()
  
    // API
    const getLeague = async () => {
        try {
            const data = await LeagueService.getLeagueById(leagueId)
            setLeague(data)
        } catch (err) {
          console.log("Error fetching fixtures. ", err);
          HelperService.showNotfyErr(notyf, err, "Error fetching fixtures.");
        }
    };
    
  const startLeague = async () => {
    try {
        await AdminLeagueService.startLeague(leagueId)
        notyf.success("Fixtures calculated for new league.")
    } catch (err) {
      console.log("Error creating fixtures. ", err);
      HelperService.showNotfyErr(notyf, err, "Error creating fixtures.");
    }
  };
    
  const deleteFixtures = async () => {
    try {
        await AdminLeagueService.deleteFixtures(leagueId)
        notyf.success("Successfully removed fixtures.")
    } catch (err) {
      console.log("Error deleting fixtures. ", err);
      HelperService.showNotfyErr(notyf, err, "Error deleting fixtures.");
    } finally {
      refresh()
    }
  };

  const updateLeagueStats = async (id: string) => {
    try {
      await AdminLeagueService.updateLeagueStats(id);
    } catch (err) {
      console.log("Error updating league stats: ", err);
      HelperService.showNotfyErr(notyf, err, "Error updating league stats.");
    }
  }
    

    // Methods
    const handleClickCreate = async () => {
      await startLeague()
      await updateLeagueStats(leagueId)
      refresh()
    }

    const handleClickDelete = async () => {
      await deleteFixtures()
    };

    // Hooks
    useEffect(() => {
        getLeague()
    }, [])


  return (
    <div>
        <div>
          <div className="modal-header">
            <h5 className="modal-title">Start League</h5>
            <button type="button" className="btn-close" aria-label="Close"></button>
          </div>
          <div className="modal-body">
          <p>Starting a league recalculates the fixtures for a season and resets the Team Hub stats.</p>
          <h6>Preparation Checklist:</h6>
          <ul>
            <li>Add and remove the relegated/promoted teams first.</li>
            <li>Start the League.</li>
          </ul>
          <h6>League details:</h6>
            <div>League: {league?.leagueName}</div>
            <div>Division: {league?.division}</div>
            <div>Console: {league?.console}</div>
            <div>Continent: {league?.continent}</div>
            <div>Dates: {league?.dates.join(', ')}</div>
            <div>Start Date: {league?.startDate}</div>
            <div>Times: {league?.times.join(', ')}</div>
            <div>Rounds: {league?.rounds}</div>
            <div>Fixtures: {league?.fixtures?.length}</div>
            <div>Teams: {league?.teams?.length}</div>
        </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={refresh}>Close</button>
            <button type="button" className="btn btn-primary" onClick={handleClickCreate}>Start League</button>
          </div>
        </div>
      </div>

  );
};

export default StartLeagueModal;

